import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { useGetUsersByAccountAndSoftwareQuery } from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { DecreaseOriginalValueEntryList } from './DecreaseOriginalValueList/DecreaseOriginalValueEntryList'

export const DecreaseOriginalValueMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  /* -------------------------------------------- */
  /*                   VARIABLES                  */
  /* -------------------------------------------- */

  const approvalStatusEnum = [
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Approved', ID: 'COMPLETED' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'All', ID: 'ALL' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  let dummyData = [
    {
      ID: 1,
      Name: 'Asset Name',
      Category: 'Asset Category',
      InitialValue: 2000,
      UpdatedValue: 3440,
      ChangeDate: '2021-05-27T12:44:01.162Z',
      Remark: 'Remark here',
      ApprovalStatus: 'ACTIVE',
      AssetNo: 'AS1001',
      Description: null,
    },
    {
      ID: 2,
      Name: 'Computer',
      Category: 'Office Equipment',
      InitialValue: 2000,
      UpdatedValue: 3440,
      ChangeDate: '2023-11-10',
      Remark: 'Remark here',
      ApprovalStatus: 'SUBMIT',
      AssetNo: 'AS1002',
      Description: null,
    },
    {
      ID: 3,
      Name: 'Asset Name',
      Category: 'Asset Category',
      InitialValue: 2000,
      UpdatedValue: 3440,
      ChangeDate: '2021-05-27T12:44:01.162Z',
      Remark: 'Remark here',
      ApprovalStatus: 'SUBMIT',
      AssetNo: 'AS1003',
      Description: null,
    },
    {
      ID: 4,
      Name: 'Computer',
      Category: 'Office Equipment',
      InitialValue: 2000,
      UpdatedValue: 3440,
      ChangeDate: '2023-11-10',
      Remark: 'Remark here',
      ApprovalStatus: 'COMPLETED',
      AssetNo: 'AS1004',
      Description: 'Direct Purchase',
    },
  ]

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({ fetchPolicy: 'network-only' })

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */

  const { handleSearch, setOriginalListing } = useFuseSearch()

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  return (
    <>
      {UserLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'SUBMIT'
            ? setOpenExitConf(true)
            : history.push(`/fixed-assets/${CompanyID}/assets-change`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Decrease in Original Value', current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter ">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {}}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
          }}
          isDefaultValue={!!getSearch?.name}
        />

        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'REJECTED') && (
        <DecreaseOriginalValueEntryList
          filteredList={dummyData}
          listStatus={listStatus}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
        />
      )}

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/fixed-assets/${CompanyID}`)
        }}
      />
    </>
  )
}
